'use client';

import { type ComponentProps, createContext, type ReactNode, useContext } from 'react';
import type StyleButton from '@alltrails/maps/components/StyleButton/StyleButton';

/**
 * What the shared explore map contributes to a control rendered in one of its slots. A parallel
 * route slot is a sibling of ExploreMap rather than a child, so these cannot arrive as props —
 * and they belong to the map, not to the route, which is why the route does not supply them.
 */
export type ExploreMapControlsContextValue = Pick<ComponentProps<typeof StyleButton>, 'handleFailedEntitlementCheck'> & {
  /** True while any layer upsell is open, so a control's own focus trap can stand aside for it */
  isLayerUpsellOpen: boolean;
  /** A second instance of the live map's overlays, for a control that renders a map of its own */
  mapOverlays: ReactNode;
};

const ExploreMapControlsContext = createContext<ExploreMapControlsContextValue | null>(null);

export const ExploreMapControlsProvider = ExploreMapControlsContext.Provider;

export const useExploreMapControls = (): ExploreMapControlsContextValue => {
  const value = useContext(ExploreMapControlsContext);
  if (!value) {
    throw new Error('useExploreMapControls must be used within an ExploreMapControlsProvider');
  }
  return value;
};
